import React from 'react';
import FormInput from '../../input/FormInput';
import CompoundSubtraction from '../../input/compound/CompoundSubtraction';
import { Grid } from '@mui/material';

const GrossTareNet = ({ props }) => {
    return (
        <>
            <Grid container spacing={1}>
                <>
                    <Grid item xs={12}>
                        <FormInput name="gross_weight" props={props.gross_weight} />
                    </Grid>
                    <Grid item xs={12}>
                        <FormInput name="tare_weight" props={props.tare_weight} />
                    </Grid>
                    <Grid item xs={12}>
                        <CompoundSubtraction name="net_weight" props={props.net_weight} references={['gross_weight', 'tare_weight']} />
                    </Grid>
                </>
            </Grid>
        </>
    );
};

export default GrossTareNet;
